import axios from 'axios';
import Jsona from 'jsona';
import store from '../../store';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function getQueueCheck(profile_id, options) {
  let currentSession = localStorage.getItem("vue-authenticate.vueauth_access_token");
  let checkURL = `${url}/queue/check/`+profile_id+`?session_id=`+currentSession;
  let statusData = null;
  await axios.get(checkURL, {}, options)
  .then((res) => {
    statusData = res;
  }).catch((err) => {
    //console.log("ERROR!@");
    throw new Error(err.stack);
  });

  return statusData;
}

// Polls /queue/check until the job is finished (or data is present), exiting
// early on server-reported errors and on "dead" rows that never start.
// First poll after ~2s, then every 10s; hard cap 600s.
async function pollQueueStatus(profile_id, options, statusData) {
  const firstDelay = 2000;
  const interval = 10000; // 10s timestep to avoid spamming the endpoint.
  const maxTime = 600000; // 600s timeout (10min)
  const maxDeadPolls = 3; // ~30s of "never started" => give up
  let totalTime = 0;
  let deadPolls = 0;
  let polls = 0;

  while (statusData == null || statusData.data.finished == false) {
    if (totalTime >= maxTime) { throw new Error("Queue load timed out!"); }
    const delay = polls === 0 ? firstDelay : interval;
    await sleep(delay);
    totalTime += delay;
    polls++;
    statusData = await getQueueCheck(profile_id, options);
    const status = statusData.data;

    if (status.error === true) {
      throw new Error("Report generation failed (errorCode: " + status.errorCode + ")");
    }
    if (status.data != null) { break; }

    if (status.finished == false && !status.loading && !status.loading_started) {
      deadPolls++;
      if (deadPolls >= maxDeadPolls) { throw new Error("Report generation never started"); }
    } else {
      deadPolls = 0;
    }
  }

  return statusData;
}

async function getProfile(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  if(process.env.VUE_APP_PROD == 0) {
    return axios
      .post(`${url}/user/profile/if`, data, options)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          let errorInfo = '';
          for (const [key, value] of Object.entries(res.data)) {
            errorInfo += `<br> ${key}: ${value} <br>`;
          }
          errorInfo += `<br> API LINK: ${url}/user/profile/ife <br>`;
          throw new Error(errorInfo);
        }
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.stack);
      });
  } else {
    let statusData = null;

    //console.log(store._modules.root._children.user.state.user); //


    let currentSession = localStorage.getItem("vue-authenticate.vueauth_access_token");
    await axios
      .get(process.env.VUE_APP_API_BASE_URL + '/queue/load/' + data.profile_id, {
        params: {session_id: currentSession},
      })
      .then((res) => {
        // If the job already finished (cached/synchronous completion), the load
        // response is the final status: skip polling entirely, since a queue/check
        // for an already-consumed job is a guaranteed 500.
        // The live payload nests the status: { ..., status: { finished, data, ... } }.
        if (res && res.data && res.data.status && res.data.status.finished == true && res.data.status.data != null) {
          statusData = { data: res.data.status };
        }
      }
    );

    statusData = await pollQueueStatus(data.profile_id, options, statusData);

    if(statusData.data.error) {
      //console.log("ERROR!!!");
      throw new Error(statusData.data.errorCode);
    }

    let returnData = null;
    const maxParseAttempts = 3;
    for (let attempt = 1; attempt <= maxParseAttempts; attempt++) {
      try {
        returnData = JSON.parse(JSON.parse(statusData.data.data));
        break;
      } catch (e) {
        // A response can arrive truncated if it was in flight when the
        // backend task got cycled out mid-stream. The job itself already
        // finished server-side, so re-checking should return the same
        // completed data intact; only give up after repeated truncation.
        if (attempt === maxParseAttempts) {
          throw new Error(`Profile response was truncated after ${maxParseAttempts} attempts: ${e.message}`);
        }
        await sleep(3000);
        statusData = await getQueueCheck(data.profile_id, options);
      }
    }

    return returnData;
  }
}

async function getIndustryProfile(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  let userID = localStorage.getItem("queueUserID");
  //console.log(userID);
  if(process.env.VUE_APP_PROD == 0) {
    return axios
      .post(`${url}/user/profile/imr`, data, options)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          let errorInfo = '';
          for (const [key, value] of Object.entries(res.data)) {
            errorInfo += `<br> ${key}: ${value} <br>`;
          }
          errorInfo += `<br> API LINK: ${url}/user/profile/imr <br>`;
          throw new Error(errorInfo);
        }
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.stack);
      });
  } else {
    let statusData = null;
    //console.log(store._modules.root._children.user.state.user); //
    let currentSession = localStorage.getItem("vue-authenticate.vueauth_access_token");
    await axios
      .get(process.env.VUE_APP_API_BASE_URL + '/queue/load/' + data.profile_id, {
        params: {session_id: currentSession},
      })
      .then((res) => {
        // If the job already finished (cached/synchronous completion), the load
        // response is the final status: skip polling entirely, since a queue/check
        // for an already-consumed job is a guaranteed 500.
        // The live payload nests the status: { ..., status: { finished, data, ... } }.
        if (res && res.data && res.data.status && res.data.status.finished == true && res.data.status.data != null) {
          statusData = { data: res.data.status };
        }
      }
    );

    statusData = await pollQueueStatus(data.profile_id, options, statusData);

    if(statusData.data.error) {
      //console.log("ERROR!!!");
      throw new Error(statusData.data.errorCode);
    }

    let returnData = null;
    const maxParseAttempts = 3;
    for (let attempt = 1; attempt <= maxParseAttempts; attempt++) {
      try {
        returnData = JSON.parse(JSON.parse(statusData.data.data));
        break;
      } catch (e) {
        if (attempt === maxParseAttempts) {
          throw new Error(`Industry profile response was truncated after ${maxParseAttempts} attempts: ${e.message}`);
        }
        await sleep(3000);
        statusData = await getQueueCheck(data.profile_id, options);
      }
    }

    return returnData;
  }
}

function getReport(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/report/if`, data, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: {url}/user/report/if <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function getMarketReport(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/report/imr`, data, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/report/imr <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function saveReport(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/report/save`, data, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/report/save <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}
function getVestimateReport(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/report/valuation`, data, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/report/valuation <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function getCompanyReport(data) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/report/company`, data, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/report/valuation <br>`;
        throw new Error(errorInfo);
      }
      return res.data;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

export default {
  getProfile,
  getIndustryProfile,
  getReport,
  getMarketReport,
  getVestimateReport,
  getCompanyReport,
  saveReport,
};
